import { Dialog, Grid, Typography } from "@mui/material";
import classNames from "classnames";
import { makeStyles } from "tss-react/mui";

import warning from "../../assets/images/warning.png";
import DialogActions from "./DialogActions";
import DialogContent from "./DialogContent";
import DialogTitle from "./DialogTitle";

const useStyles = makeStyles()((theme: any) => ({
  contentSpacing: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  gridContainer: {
    alignItems: "center",
    justify: "space-around",
  },
  gridContainerImage: {
    alignItems: "center",
    justify: "center",
  },
  image: {
    width: "82px",
  },
  modalContainer: {
    margin: "auto",
    maxWidth: "703px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  subheader: {
    color: theme.palette.text.modalSubheader,
    fontSize: theme.typography.pxToRem(22),
    lineHeight: theme.typography.pxToRem(28),
  },
  text: {
    color: theme.palette.text.modalText,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(28),
  },
}));

interface ComponentPropsType {
  acceptButtonColor?: "default" | "green" | "red";
  acceptButtonText?: string;
  onAccept: () => void;
  onDismiss: () => void;
  open: boolean;
  header: string;
  subheader?: string;
  details: string;
  disableAccept?: boolean;
  id?: string;
  showCloseIcon?: boolean;
}

const ModalFormConfirmation = (props: ComponentPropsType) => {
  const { classes } = useStyles();
  const {
    acceptButtonColor = "green",
    acceptButtonText = "Continue",
    id = "modal-accept-btn",
    showCloseIcon = true,
    onAccept,
    onDismiss,
    open,
    header,
    subheader,
    details,
    disableAccept,
  } = props;
  return (
    <Dialog
      className={classes.modalContainer}
      onClose={onDismiss}
      aria-labelledby="warning-dialog-title"
      open={open}
      PaperProps={{ square: true }}
    >
      <DialogTitle
        id="warning-dialog-title"
        showCloseIcon={showCloseIcon}
        onDismiss={onDismiss}
      >
        {header}
      </DialogTitle>
      <DialogContent>
        <Grid container className={classes.gridContainer} spacing={4}>
          <Grid container item xs={3} className={classes.gridContainerImage}>
            <img src={warning} alt="Warning" className={classes.image} />
          </Grid>
          <Grid item xs>
            <Typography
              gutterBottom
              className={classNames(classes.subheader, classes.contentSpacing)}
            >
              {subheader}
            </Typography>
            <Typography
              gutterBottom
              className={classNames(classes.text, classes.contentSpacing)}
            >
              {details}
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
        acceptButtonColor={acceptButtonColor}
        acceptButtonText={acceptButtonText}
        onAccept={onAccept}
        onDismiss={onDismiss}
        disableAccept={disableAccept}
        closeButtonText="Cancel"
        id={id}
      />
    </Dialog>
  );
};

export default ModalFormConfirmation;
